import { api } from '@/lib/axios';
import {
  Client,
  CreateClientDto,
  UpdateClientDto,
  ClientsQueryDto,
  PaginatedResponse,
} from '@caruso/types';

export const clientsService = {
  async getAll(params: ClientsQueryDto): Promise<PaginatedResponse<Client>> {
    console.log('🌐 Frontend enviando params:', params);
    const response = await api.get<PaginatedResponse<Client>>('/clients', { params });
    return response.data;
  },

  async getById(id: string): Promise<Client> {
    const response = await api.get<Client>(`/clients/${id}`);
    return response.data;
  },

  async create(data: CreateClientDto): Promise<Client> {
    const response = await api.post<Client>('/clients', data);
    return response.data;
  },

  async update(id: string, data: UpdateClientDto): Promise<Client> {
    const response = await api.patch<Client>(`/clients/${id}`, data);
    return response.data;
  },

  async archive(id: string): Promise<Client> {
    const response = await api.patch<Client>(`/clients/${id}/archive`);
    return response.data;
  },

  async unarchive(id: string): Promise<Client> {
    const response = await api.patch<Client>(`/clients/${id}/unarchive`);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/clients/${id}`);
  },

  async importFromCsv(file: File): Promise<{ total: number; imported: number; errors: Array<{ row: number; error: string; data: any }> }> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/clients/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async downloadTemplate(): Promise<void> {
    const response = await api.get('/clients/export/template', {
      responseType: 'blob',
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'template_importacao_clientes.csv');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  async getFlowExecutions(id: string, page: number = 1, limit: number = 10): Promise<{
    data: any[];
    pagination: {
      page: number;
      limit: number;
      total: number;
      totalPages: number;
    };
  }> {
    const response = await api.get(`/clients/${id}/flow-executions`, {
      params: { page, limit }
    });
    return response.data;
  },

  async getMessageReadStats(id: string): Promise<{
    totalMessages: number;
    readMessages: number;
    averageReadTimeMinutes: number;
    averageReadTimeFormatted: string;
    readPercentage: number;
  }> {
    const response = await api.get(`/clients/${id}/message-read-stats`);
    return response.data;
  },

  async getOrders(id: string): Promise<any[]> {
    const response = await api.get(`/clients/${id}/orders`);
    return response.data;
  },
};